import { Box, Typography } from "@mui/material";
import React, { forwardRef } from "react";

interface DetailedSummaryProps {
  summary: Array<{
    title: string;
    detail: string;
  }>;
  optimizedMode?: boolean;
}

const DetailedSummary = forwardRef<HTMLDivElement, DetailedSummaryProps>((
  { summary, optimizedMode = false },
  ref
) => {
  return (
    <Box
      ref={ref}
      sx={{
        mt: 3,
        p: "20px",
        border: "1px solid #E6E8F0",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: "18px",
          fontWeight: "600",
          fontFamily: "Inter",
          color: "#121828",
          mb: 1,
        }}
      >
        {optimizedMode
          ? "Key Additions in Updated Article"
          : "Key Aspects of Article"}
      </Typography>

      {optimizedMode && (
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            fontFamily: "Inter",
            color: "#7B85AD",
            mb: 3,
          }}
        >
          Discover the changes behind EEAT improvements:
        </Typography>
      )}

      {summary.map((item, index) => (
        <Box
          key={index}
          sx={{
            mb: 3,
            p: 3,
            backgroundColor: "#F9FAFC",
            borderRadius: "8px",
            // border: "1px solid #E6E8F0",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              fontFamily: "Inter",
              color: "#121828",
              mb: 1,
            }}
          >
            {item.title}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              fontFamily: "Inter",
              color: "#7B85AD",
              lineHeight: 1.6,
            }}
          >
            {item.detail}
          </Typography>
        </Box>
      ))}
    </Box>
  );
});

export default DetailedSummary;
